import { Alert, Button, Card, Spinner } from "flowbite-react";
import React, { useEffect, useRef, useState } from "react";
import { isValidCNPJ, maskCEP } from "../../utils/utils";
import axios from "../../config/axiosInstance";
import { QUERIES } from "../../config/apiConfig";
import { HiInformationCircle } from "react-icons/hi";
import HeaderQuery from "./HeaderQuery";
import usePDF from "../../hooks/usePDF";
import TitleStripe from "../common/TitleStripe";
import CardQueryDescription from "../common/CardQueryDescription";
import QueryInput from "../inputs/QueryInput";
import SliderToPreview from "../common/SliderToPreview";
import QueryLoading from "../common/QueryLoading";
import FooterQuery from "./FooterQuery";
import ReactApexChart from "react-apexcharts";
import Adicionais from "../common/query/Adicionais";
import { useReactToPrint } from "react-to-print";
import { FaPrint } from "react-icons/fa";
import AdditionalQueryPJ from "../common/query/AdditionalQueryPJ";
import AdditionalQueryAdvancedPJ from "../common/query/AdditionalQueryAdvancedPJ";

const RelatorioAvancadoPJQuery = ({
  query,
  selectedPrice,
  dataFromLocalStorage = null,
  hasHeaderPDF = "true",
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [info, setInfo] = useState("");
  const [document, setDocument] = useState("");
  const [error, setError] = useState("");
  const [errorData, setErrorData] = useState("");
  const [data, setData] = useState(null);
  const [isDoneRequest, setIsDoneRequest] = useState(false);
  const [selectedQueries, setSelectedQueries] = useState([]);
  const [dataAdditionals, setDataAdditionals] = useState(null);
  const [dataPerfilAdditionals, setDataPerfilAdditionals] = useState(0);
  const componentRef = useRef();
  const printRef = useRef();
  const reactToPrintFn = useReactToPrint({ contentRef: printRef });

  useEffect(() => {
    if (dataFromLocalStorage) {
      setDataAdditionals(dataFromLocalStorage.additionals);
      setDocument(dataFromLocalStorage?.consultaCredito?.dadosCadastrais?.cnpj);
      setIsDoneRequest(true);
    }
  }, []);

  const fetchDefineRisco = async (raw) => {
    return await axios(
      `${QUERIES.GET_V2_QUERY}/relatorio-avancado-pj/${info.replace(
        /\D/g,
        ""
      )}?additionals=${selectedQueries}&perfil=${dataPerfilAdditionals}`
    );
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setDocument(info);

    const unmaskedValue = info.replace(/\D/g, "");
    let isValid = true;

    if (!isValidCNPJ(unmaskedValue)) {
      setError("CNPJ inválido!");
      isValid = false;
    }

    if (isValid) {
      try {
        setData(null);
        setIsLoading(true);
        setError("");
        setErrorData("");
        setIsDoneRequest(false);
        setDataAdditionals(null);

        const { data: dados } = await fetchDefineRisco();
        setData(dados.data.consultaCredito || { status: "ok" });
        setDataAdditionals(dados.data.additionals);
        setIsLoading(false);
      } finally {
        setIsDoneRequest(true);
      }
    } else {
      setData(null);
    }
  };

  return (
    <div>
      {!dataFromLocalStorage && (
        <>
          <CardQueryDescription
            title="Informações da consulta"
            infos={[
              "Dados Cadastrais",
              "Score",
              "Negativações",
              "Protestos",
              "Protestos Dir. Cartório",
              "Cheques sem fundos",
              "Cheques sustados",
            ]}
            price={selectedPrice}
          >
            <form
              className="flex flex-col gap-2 bg-white p-2 mt-2 rounded-lg shadow-md w-fit mb-4"
              onSubmit={handleSubmit}
            >
              <div className="flex flex-col md:flex-row gap-2 items-center">
                <QueryInput
                  info={info}
                  setInfo={setInfo}
                  isLoading={isLoading}
                  error={error}
                  type="CNPJ"
                  additionals={selectedQueries}
                />
                <div>
                  {!errorData && data && (
                    <Button
                      className="bg-gray-600"
                      onClick={() => reactToPrintFn()}
                    >
                      <div className="flex gap-2 items-center">
                        <FaPrint />
                        <div>Imprimir</div>
                      </div>
                    </Button>
                  )}
                </div>
              </div>
            </form>

            <AdditionalQueryAdvancedPJ
              setSelectedQueries={setSelectedQueries}
              selectedQueries={selectedQueries}
              setDataPerfilAdditionals={setDataPerfilAdditionals}
              dataPerfilAdditionals={dataPerfilAdditionals}
              type="J"
            />
          </CardQueryDescription>
        </>
      )}

      <SliderToPreview />

      {errorData ? (
        <Alert color="failure" icon={HiInformationCircle}>
          <span className="font-medium">{errorData}</span>
        </Alert>
      ) : (
        <>
          <div
            className={`overflow-x-scroll print-content mobile-fit ${
              data || isLoading || dataAdditionals ? "block" : "hidden"
            }`}
            ref={(el) => {
              componentRef.current = el;
              printRef.current = el;
            }}
          >
            {!isLoading ? (
              <>
                <Card className="mt-0 p-4 card-pdf relative overflow-hidden">
                  <HeaderQuery title={query?.name} hasHeader={hasHeaderPDF} />

                  <Adicionais
                    additionals={dataAdditionals}
                    selectedQueries={selectedQueries}
                  />

                  <FooterQuery hasHeader={hasHeaderPDF} />
                </Card>
              </>
            ) : (
              <QueryLoading />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default RelatorioAvancadoPJQuery;
